/** 通知許諾の事前案内カルーセル。最後のスライドで OS の許諾ダイアログへ誘導する */
export const pushSoftAsk = {
  slides: {
    renewed: {
      title: "通知が\nもっと使いやすくなりました",
      body: {
        line1: "これまですべての通知をお届けしていましたが、",
        emphasis: "必要",
        line2: "な通知だけに絞りました。",
      },
    },
    targets: {
      title: { before: "届くのはこの", emphasis: "4", after: "つだけ" },
      items: [
        { label: "会話中の女の子" },
        { label: "お気に入りの女の子" },
        { label: "いいねした女の子" },
        { label: "好みの女の子", sub: "（パーソナライズ済みの方のみ）" },
      ],
    },
    benefits: {
      title: "お得な情報だけが届きます",
      items: [
        "ボーナスポイントが出現したとき",
        "お気に入りにした相手から連絡があったとき",
        "好みの女の子を、いち早くお知らせ",
      ],
    },
    toggle: {
      title: "好みの女の子の通知は\nお好みでON / OFF",
      body: "アプリ内の設定から、好みの女の子の通知だけを自由に切り替えられます。",
    },
    settings: {
      title: "お得な通知を受け取りませんか？",
      body: "通知は現在OFFになっています。\n設定アプリで「通知を許可」をONにしてください。",
    },
    permission: {
      title: "お得な通知を受け取りませんか？",
      body: "次の画面で「許可」をタップしてください。\n通知はいつでも設定から変更できます。",
    },
  },
  next: "次へ",
  openSettings: "設定を開く",
  accept: "通知を受け取る",
  decline: "今はしない",
  done: "閉じる",
  headerMail: {
    label: "お知らせ",
    listTitle: "お知らせ",
    popup: "通知が便利になりました",
    badge: "NEW",
    unset: "未設定",
    close: "閉じる",
  },
  carouselLabel: "通知のご案内",
} as const;
